import * as stylex from "@stylexjs/stylex";
import { LogOut, MonitorSmartphone } from "lucide-react";
import { useId } from "react";
import { copy } from "@/copy";
import "@/theme/seasons.stylex";
import { season } from "@/theme/seasons.stylex";
import "@/theme/tokens.stylex";
import { radii, shadows } from "@/theme/tokens.stylex";
import { Button } from "@/ui/Button";
import { Dialog } from "@/ui/Dialog";
import { Eyebrow } from "@/ui/Eyebrow";
import { Icon } from "@/ui/Icon";
import type { SignOutDialog as SignOutDialogState } from "../signOutDialog";
type SignOutDialogProps = {
  email: string;
  online: boolean;
  state: Exclude<SignOutDialogState, {
    kind: "closed";
  }>;
  onThisDevice: () => void;
  onAllDevices: () => void;
  onCancel: () => void;
};
const text = copy.settings.account.signOutDialog;
const styles = {
  ring: {
    kGVxlE: "xnfxhx2",
    $$css: true
  }
};
export function SignOutDialog({
  email,
  online,
  state,
  onThisDevice,
  onAllDevices,
  onCancel
}: SignOutDialogProps) {
  const titleId = useId();
  const busy = state.kind === "signing-out";
  return <Dialog labelledBy={titleId} onClose={onCancel}>
      <span className="xrvj5dj x1ku5rj1 x1fu8urw x1peatla x2lah0s xqhrb7l x1ubcl0s">
        <Icon icon={LogOut} size={28} strokeWidth={1.5} />
      </span>
      <div className="x78zum5 xdt5ytf x1v2ro7d">
        <Eyebrow>{email}</Eyebrow>
        <h2 id={titleId} className="x1ghz6dp xneq65o x1v94iar xrg9stw x1159mfc">
          {text.title}
        </h2>
        <p className="x1ghz6dp x1j61zf2 x15i68ds xfrs9s4 x1fzhlzt">{text.body}</p>
      </div>
      <div className="x78zum5 xdt5ytf x1v2ro7d">
        <Button variant="secondary" icon={LogOut} fullWidth disabled={busy} onClick={onThisDevice} xstyle={styles.ring}>
          {text.thisDevice}
        </Button>
        <Button icon={MonitorSmartphone} fullWidth disabled={busy || !online} onClick={onAllDevices}>
          {text.allDevices}
        </Button>
        <Button variant="ghost" fullWidth onClick={onCancel}>
          {text.cancel}
        </Button>
      </div>
      {state.kind === "failed" && <p role="alert" className="x1ghz6dp x1jvydc1 x15i68ds x37zpob">
          {text.failed}
        </p>}
    </Dialog>;
}